export default {
  Helptext1: "Various search terms can be separated by space (The search result will contain the string).",
  Helptext2: "Double quote '...' will search for an exact string (in some cases this could speed up the search).",
  Helptext3: "It is also possible to search for multiple exact strings '...' '...' '...'.",
  globalErrorMessageHeader: "Error",
  globalErrorMessage:
    "An error has been occurred during your request and the IT support has been informed. We will resolve this issue as soon as possible and are sorry for the inconvenience.",
  createOrSelectTags: "Create or select tags",
};
